/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import firebase from "firebase";
import Modal from "react-modal";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ErrorMessage } from "@hookform/error-message";
import Swal from "sweetalert2";
import { ForgetPasswordSchema } from "../utils/validationSchema";
import { FormError } from "../components";
import { firebaseConfig } from "../firebase/firebase";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    transition: "all .4s ease",
    width: "55%",
    backgroundColor: "#ffffff !important",
    zIndex: 11111111111,
  },
};

export const ForgetPasswordModal = ({ modalIsOpen, setIsOpen }) => {
  let subtitle;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(ForgetPasswordSchema),
  });

  const afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const onSubmit = (data) => {
    const userEmail = data.email;
    firebase
      .auth()
      .sendPasswordResetEmail(userEmail)
      .then(() => {
        Swal.fire({
          icon: "success",
          text: "Email Send, please check your email!",
          confirmButtonText: "Close",
          confirmButtonColor: "#4e4e4e",
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
          confirmButtonText: "Close",
          confirmButtonColor: "#4e4e4e",
        });
      });
  };

  return (
    <Modal
      closeTimeoutMS={500}
      isOpen={modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal">
      <h2
        style={{ display: "inline-block" }}
        ref={(_subtitle) => {
          subtitle = _subtitle;
        }}>
        Change Password
      </h2>
      <button
        type="button"
        style={{
          float: "right",
          lineHeight: 2,
          backgroundColor: "#fff",
          border: 0,
        }}
        onClick={closeModal}>
        <i className="fa fa-times-circle text-dark" />
      </button>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal-body">
          <p className="lead">
            You have requested to reset your <br /> password
          </p>
          <div className="input-group my-5">
            <input
              type="email"
              {...register("email")}
              className="form-control"
              placeholder="Enter Email to Send Reset Password Link...."
            />
            <div className="input-group-append">
              <div className="input-group-text">
                <span className="fas fa-envelope" />
              </div>
            </div>
          </div>
          <ErrorMessage errors={errors} name="email" render={FormError} />
          <div>
            <button type="submit" className="m-auto btn btn-dark btn-lg float-right">
              Submit
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

ForgetPasswordModal.propTypes = {
  modalIsOpen: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
};

ForgetPasswordModal.defaultProps = {
  modalIsOpen: false,
};
